import fallBackImage from 'assets/images/placeholder_artwork02.jpg';
import {
  ReleaseFieldType,
  type ReleaseData,
} from 'services/store/distribution/types';
import {
  StyledInnerContainer,
  CoverArt,
  ArtistName,
  SongTitle,
  ReleaseBaseInfoContainer,
  ReleaseInfoContainer,
  StyledOuterContainer,
  StyledChip,
} from './styled';
import SongsList from './components/SongsList';

type PropsType = {
  release: ReleaseData;
};

const ReleaseInfo = ({ release }: PropsType) => {
  const coverArt = release[ReleaseFieldType.CoverArt].data || fallBackImage;
  const songTitle = release[ReleaseFieldType.SongTitle].data;
  const artistName = release[ReleaseFieldType.ArtistName].data || '-';
  const chipLabel = release[ReleaseFieldType.Genre].data?.name || '-';

  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <CoverArt src={coverArt} alt="artwork missing" />
        <ReleaseInfoContainer>
          <ReleaseBaseInfoContainer>
            <SongTitle>{songTitle}</SongTitle>
            <ArtistName>{artistName}</ArtistName>
          </ReleaseBaseInfoContainer>
          <StyledChip label={chipLabel} />
        </ReleaseInfoContainer>
      </StyledInnerContainer>
      <SongsList songsData={release.songs} />
    </StyledOuterContainer>
  );
};
export default ReleaseInfo;
